import React from 'react';
import { useLocation } from 'react-router-dom';
import { FiGithub, FiTwitter, FiLinkedin, FiInstagram } from 'react-icons/fi';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const location = useLocation();
  const isPrivacyPage = location.pathname === '/privacy-policy';
  const isTermsPage = location.pathname === '/terms-of-service';
  const isCookiePage = location.pathname === '/cookie-policy';
  
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-grid">
          {/* Company Info */}
          <div className="footer-company">
            <h3 className="footer-logo">StoryCape</h3>
            <p className="company-description">
              Engage your users with interactive stories in your mobile app.
            </p>
            <div className="social-links">
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="social-link">
                <FiTwitter size={20} />
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="social-link">
                <FiLinkedin size={20} />
              </a>
              <a href="https://github.com" target="_blank" rel="noopener noreferrer" className="social-link">
                <FiGithub size={20} />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="social-link">
                <FiInstagram size={20} />
              </a>
            </div>
          </div>
          
          {/* Quick Links */}
          <div className="footer-links">
            <h4 className="footer-title">Product</h4>
            <ul className="footer-list">
              <li><a href="#features" className="footer-link">Features</a></li>
              <li><a href="#pricing" className="footer-link">Pricing</a></li>
              <li><a href="/" className="footer-link">Documentation</a></li>
            </ul>
          </div>
          
          {/* Resources */}
          <div className="footer-links">
            <h4 className="footer-title">Resources</h4>
            <ul className="footer-list">
              <li><a href="/" className="footer-link">Blog</a></li>
              <li><a href="/" className="footer-link">Case Studies</a></li>
              <li><a href="/" className="footer-link">Help Center</a></li>
              <li><a href="#faq" className="footer-link">FAQ</a></li>
            </ul>
          </div>
          
          {/* Company */}
          <div className="footer-links">
            <h4 className="footer-title">Company</h4>
            <ul className="footer-list">
              <li><a href="/" className="footer-link">About Us</a></li>
              <li><a href="#contact" className="footer-link">Contact</a></li>
              <li><a href="/" className="footer-link">Careers</a></li>
              <li>
                {isPrivacyPage ? (
                  <span className="footer-link active">Privacy</span>
                ) : (
                  <a href="/privacy-policy" className="footer-link">Privacy</a>
                )}
              </li>
              <li>
                {isTermsPage ? (
                  <span className="footer-link active">Terms</span>
                ) : (
                  <a href="/terms-of-service" className="footer-link">Terms</a>
                )}
              </li>
            </ul>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p className="copyright">
            &copy; {currentYear} StoryCape. All rights reserved.
          </p>
          <div className="legal-links">
            {isPrivacyPage ? (
              <span className="legal-link active">Privacy Policy</span>
            ) : (
              <a href="/privacy-policy" className="legal-link">Privacy Policy</a>
            )}
            {isTermsPage ? (
              <span className="legal-link active">Terms of Service</span>
            ) : (
              <a href="/terms-of-service" className="legal-link">Terms of Service</a>
            )}
            {isCookiePage ? (
              <span className="legal-link active">Cookie Policy</span>
            ) : (
              <a href="/cookie-policy" className="legal-link">Cookie Policy</a>
            )}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;